import { Component, OnInit, ViewChild, ElementRef, Inject, NgZone } from '@angular/core'; 
import { ActivatedRoute, Router } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from "@angular/forms";  
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@services/security';
import { AppConsts } from '@shared/app-consts';  
import { ResetPasswordRequest } from '@shared/ResetPasswordRequest';
import { RecaptchaService } from '@services/security/recaptcha-service';


@Component({
  standalone: false,
  selector: 'app-send-token-possword',
  templateUrl: './send-token-possword.component.html',
  styleUrls: ['./send-token-possword.component.scss'] 
})
export class SendTokenResetPasswordComponent implements OnInit  { 
    submitted:boolean=false;
    resetPasswordForm:FormGroup;      
    resetPasswordModel:ResetPasswordRequest;
    email:string;
    infoMessage:string;   
    step:number = 1;
    emailPattern: string = AppConsts.EMAIL_PATTERN;
    errorMessage: string="";

    get f() { return this.resetPasswordForm.controls; }
    @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;
    submitWithCaptcha = RecaptchaService.submitWithCaptcha;
    constructor(private route: ActivatedRoute,private service: AuthenticationService,
      private router: Router,
      public formBuilder: FormBuilder,
      @Inject(DOCUMENT) private _document,  private zone: NgZone) {
      }

        
  ngOnInit() {  
    this.step = 1;
    this.resetPasswordModel = new ResetPasswordRequest('','');  
    this.buildForm(); 
  }

  handleValidSubmit = (event) =>{
    event.preventDefault();
    this.submitWithCaptcha(this.sendMailTokenPassword.bind(this),event,"submit");
  }

  ngAfterViewInit() { 
  }  

 buildForm(){
    this.resetPasswordForm = this.formBuilder.group({ 
      Email: [
        "",
        Validators.compose([
          Validators.maxLength(100),
          Validators.pattern(this.emailPattern),
          Validators.required
        ])
      ]
    });
    
    this.resetPasswordForm.controls['Email'].valueChanges.subscribe((value) => {  
        this.resetPasswordModel.Email = value; 
        }); 
 }

 sendMailTokenPassword(event,recaptchaToken){
  this.submitted = true;
  
  if(this.resetPasswordForm.invalid)
     return;      

   this.resetPasswordModel.RecaptchaToken = recaptchaToken ;
   this.service.SendTokenResetPassword(this.resetPasswordModel).subscribe((response : any)=>{
   if(response != null && response && response.IsSuccess)
    {
      this.step = 2;
      this.recaptchaElement.nativeElement.style.display='none';
    }
    else if(response != null && response && !response.IsSuccess)
    {
      this.errorMessage = response.ErrorMessage;
    }
    else
    {
      this.errorMessage = "Erreur inconnue. Veuillez-vérifier l'adresse mail saisie."
    }
  }); 
 } 

 redirectToLogin(){
  this.router.navigate(['/login']);
 }
}
